import React from "react";
import "../styles/ErrorNotFound.css";

function ErrorPage() {
  return (
    <div className="error-container">
      <i
        className="fa fa-exclamation-triangle error-icon"
        aria-hidden="true"
      ></i>
      <div className="error-message">
        Error 404: Page not found due to unavailable API data
      </div>
      <div className="error-suggestion">Please try again later</div>
    </div>
  );
}

export default ErrorPage;
